import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/r/$restaurantId/s/app-store-links')({
  component: Component,
});

function Component() {
  return <div>Hello /r/$restaurantUuid/(settings)/app-store-links!</div>;
}
